<template>
  <b-tabs v-model="activeTab" v-observe-visibility="changeVisibility">
    <b-tab>
      <template slot="title">
        <i class="icon-list"></i>
      </template>
      <vis-notifications :visible="visible && sidebarTabs.notifications === activeTab"></vis-notifications>
    </b-tab>
    <b-tab v-if="currentUser.IsEmployee">
      <template slot="title">
        <i class="icon-speech"></i>
      </template>
      <vis-chat-launcher/>
    </b-tab>
    <b-tab>
      <template slot="title">
        <i class="icon-settings"></i>
      </template>
      <vis-app-preset></vis-app-preset>
    </b-tab>
  </b-tabs>
</template>

<script>
import VisAppPreset from "@/views/vis-app-preset";
import VisChatLauncher from "@/views/vis-chat-launcher";
import VisNotifications from "@/views/vis-notifications";
import eventBus from '@/shared/global-events';
import { VisGlobalEventTypes } from '@/shared/enum/global-event-types'
import { sidebarTabs } from '@/shared/classes'
import globalState from "@/shared/global-state";

export default {
  name: "vis-aside-tabs",
  components: {
    VisAppPreset,
    VisChatLauncher,
    VisNotifications,
  },
  data() {
    return {
      visible: false,
      sidebarTabs: sidebarTabs,
      activeTab: 0,
      currentUser: globalState?.currentUser || {}
    }
  },
  methods: {
    changeVisibility(val) {
      this.visible = val
    },
    activateTab(payload) {
      const { activeTab } = payload;
      this.activeTab = activeTab;
    }
  },
  mounted() {
    eventBus.on(VisGlobalEventTypes.TOGGLE_SIDEBAR, this.activateTab)
  },
  beforeDestroy() {
    eventBus.off(VisGlobalEventTypes.TOGGLE_SIDEBAR, this.activateTab)
  }
};
</script>
